import React, { useEffect, useState } from "react";
import axios from "axios";
import { LogOut } from "lucide-react";
import { Link } from "react-router-dom";

const Profile = () => {
  const [profile, setProfile] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(true);

  const email = sessionStorage.getItem("email");

  useEffect(() => {
    if (email) {
      fetchProfile(email);
    }
  }, [email]);

  // ✅ FETCH PROFILE
  const fetchProfile = async (email) => {
    try {
      const res = await axios.get(
        "https://api.nfcdesignstudio.com/API/v1/api/profilee"
      );
      const allUsers = res.data.data;
      const matchedUser = allUsers.find((u) => u.email === email);
      if (!matchedUser) {
        console.error("No matching user found");
        setLoading(false);
        return;
      }
      setProfile(matchedUser);
      setName(matchedUser.username);
      setMobile(matchedUser.mobile);
      setLoading(false);
    } catch (err) {
      console.error("Error loading profile:", err);
      setLoading(false);
    }
  };

  // ✅ UPDATE PROFILE
  const updateProfile = async () => {
    try {
      await axios.put(
        "https://api.nfcdesignstudio.com/API/v1/profile/update",
        {
          email: profile.email,
          username: name,
          mobile,
        }
      );

      alert("Profile Updated Successfully!");

      setProfile({
        ...profile,
        username: name,
        mobile,
      });

      setEditMode(false);
    } catch (err) {
      console.error("Update failed:", err);
      alert("Update Failed");
    }
  };

  const handleLogout = () => {
    const confirmLogout = window.confirm("Are you sure you want to logout?");

    if (confirmLogout) {
      sessionStorage.clear();   // clear session storage
      localStorage.clear();
      localStorage.removeItem("email"); // optional if needed
      window.location.href = "/";  // redirect to home/login
    }
  };

  if (loading) return <div style={{ padding: 40 }}>Loading...</div>;

  return (
    <>
      <div style={{ flexShrink: 0, borderBottom: '1px solid #ccc', background: 'rgba(255,255,255,0.5)', backdropFilter: 'blur(10px)', padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
        <div>
          <h2 style={{ fontSize: 24, fontWeight: 'bold', margin: 0 }}>Digital Card Builder</h2>
          <p style={{ fontSize: 14, color: '#555', margin: 0 }}>Create your professional NFC business card</p>
        </div>

        {/* Links */}
        <div style={{ display: 'flex', gap: '16px' }}>
          <Link to="/builder" style={{ textDecoration: "none", color: "#007bff", fontWeight: "500" }}>MY Card</Link>
          {/* <a href="/vfc-card" style={{ textDecoration: 'none', color: '#007bff', fontWeight: '500' }} > VFC Card</a> */}
          <a href="/profile" style={{ textDecoration: 'none', color: '#007bff', fontWeight: '500' }}> Profile</a>
          <a onClick={handleLogout} style={{ display: "flex", alignItems: "center", gap: "6px", textDecoration: "none", color: "#007bff", fontWeight: "500", cursor: "pointer" }}><LogOut size={16} /> Logout</a>
        </div>
      </div>

      <div style={styles.container}>
        <div style={{ padding: "30px", textAlign: "center" }}>
          <h1 style={{ color: "#0158a2" }}>PROFILE DETAILS</h1>
          <p>Here is your Profile Details</p>
        </div>

        <div style={styles.card}>
          <div style={styles.row}>
            <label>Name</label>
            {editMode ? (
              <input
                style={styles.input}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            ) : (
              <p>{profile.username}</p>
            )}
          </div>

          <div style={styles.row}>
            <label>Email</label>
            <p>{profile.email}</p>
          </div>

          <div style={styles.row}>
            <label>Mobile</label>
            {editMode ? (
              <input
                style={styles.input}
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />
            ) : (
              <p>{profile.mobile}</p>
            )}
          </div>

          {!editMode ? (
            <button style={styles.btn} onClick={() => setEditMode(true)}>
              Edit Profile
            </button>
          ) : (
            <button style={styles.btnSave} onClick={updateProfile}>
              Save Changes
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default Profile;

const styles = {
  container: {
    minHeight: "100vh",
    background: "#f4f6f9",
    padding: "20px",
  },
  card: {
    maxWidth: "500px",
    margin: "0 auto",
    background: "#fff",
    padding: "30px",
    borderRadius: "12px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
  },
  row: {
    marginBottom: "20px",
    display: "flex",
    flexDirection: "column",
  },
  input: {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
  },
  btn: {
    padding: "10px 15px",
    background: "#0158a2",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
  btnSave: {
    padding: "10px 15px",
    background: "green",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
};
